import { createSlice } from '@reduxjs/toolkit'

const globalSlice = createSlice({
  name: 'global',
  initialState: {
    documents: {
      termsAndConditions: {},
      privacyAndPolicy: {},
    },
    menu: {
      isHidden: false,
    },
  },
  reducers: {
    setTermsAndConditions(state, action) {
      state.documents.termsAndConditions = action.payload
    },
    setPrivacyAndPolicy(state, action) {
      state.documents.privacyAndPolicy = action.payload
    },
    hideMenu(state, action) {
      state.menu.isHidden = true
    },
    showMenu(state, action) {
      state.menu.isHidden = false
    },
  },
})

export const {
  setTermsAndConditions,
  setPrivacyAndPolicy,
  hideMenu,
  showMenu,
} = globalSlice.actions

export default globalSlice.reducer
